export class StradaDTO {
	tipoToponimo: string;
	inidirizzo: string;
	civico: string;
}